import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import RiskSelectionSidePanel from 'components/riskRegister/riskSelectionSidePanel/components/RiskSelectionSidePanel';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <AppWrapper {...contextProps}>
      <RiskSelectionSidePanel {...wrappedProps} />
    </AppWrapper>
  );
}
